import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Vérifier l'accès et l'authentification
  useEffect(() => {
    // Vérifier si l'accès admin a été accordé via le token
    const accessGranted = sessionStorage.getItem('adminAccessGranted');
    if (!accessGranted) {
      // Pas d'accès, rediriger vers l'accueil
      navigate('/', { replace: true });
      return;
    }
    
    // Vérifier si l'utilisateur est déjà connecté
    if (apiService.isAuthenticated()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    console.log('Tentative de connexion avec:', {
      username: credentials.username,
      password: credentials.password
    });

    try {
      const response = await apiService.login(credentials);
      console.log('Réponse du serveur:', response);
      
      if (response.success) {
        console.log('Connexion réussie, redirection...');
        navigate('/admin/dashboard');
      } else {
        console.log('Erreur de connexion:', response.error);
        setError(response.error || 'Erreur lors de la connexion');
      }
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      setError('Erreur lors de la connexion: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="container">
        <div className="login-container">
          <div className="login-header">
            <h1>🔐 Administration</h1>
            <p>Connectez-vous pour accéder au tableau de bord</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur:</label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleInputChange}
                required
                placeholder="Entrez votre nom d'utilisateur"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe:</label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                required
                placeholder="Entrez votre mot de passe"
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary btn-large"
              disabled={isLoading}
            >
              {isLoading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          
          <div className="back-to-site">
            <button 
              onClick={() => navigate('/')} 
              className="btn btn-outline"
            >
              ← Retour au site
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;